import React from 'react'
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

function Header(props) {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/');
  };


  return (
    <header>
      <div className="container d-flex align-items-center g-0">
        <button onClick={handleClick} >
          <img
            src={props.path}
            alt="ICICI Bank Logo"
            width={252}
            height={50}
            className="img-fluid"
          />
        </button>
        <h2>Home Loan</h2>
      </div>

    </header>
  );
}
Header.propTypes = {
  path: PropTypes.string.isRequired,
};
export default Header;
